import { Component } from '@angular/core';

@Component({
  templateUrl: 'addrepoagent.component.html'
})
export class AddrepoagentComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/agencies/addrepoagent.component.ts